module.exports = __webpack_public_path__ + "static/media/Expense.69abeb02.svg";